export function replaceIfEmpty(
  text: string | number | null | undefined,
  replace = '-'
) {
  if (!text) return replace;
  if (typeof text === 'number') text = text.toString();
  return text.trim() || replace;
}
